/**
 * DTO used for inviting representatives
 */
export class InviteRepresentativeRequestDTO {
  /**
   * @constructor
   */
  constructor(public email: string) {}
}
